import React from 'react'

export default function CustomAmount({
    maxRefundableAmount=0,
    isVisible=false,
    customAmount,
    setCustomAmount=() => {},
}) {
    return isVisible && (
        <div className="form-group input-group">
            <div className="input-group-prepend">
                <span className="input-group-text" children='$' />
            </div>
            <input
                className="form-control"
                type="number"
                placeholder="0.00"
                step=".01"
                min="0.01"
                max={maxRefundableAmount}
                name="amount"
                value={customAmount || ''}
                onChange={(e) => setCustomAmount(e.target.value)}
            />
        </div>
    )
}
